import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { DashboardOutlined, UserOutlined, HomeOutlined } from "@ant-design/icons";

const BottomTabBar = () => {
  const history = useHistory();
  const location = useLocation();
  const userRole = useSelector((state) => state.roleReducer.userRole);

  const adminItems = [
    { key: "/dashboard", icon: <DashboardOutlined />, label: "Dashboard" },
    { key: "/user", icon: <UserOutlined />, label: "User Master" },
    { key: "/address", icon: <HomeOutlined />, label: "Address Master" },
  ];

  const userItems = [
    { key: "/dashboard", icon: <DashboardOutlined />, label: "Dashboard" },
    { key: "/address", icon: <HomeOutlined />, label: "Address Master" },
  ];

  const items = userRole === "admin" ? adminItems : userItems;

  return (
    <div className="bottom-tab-bar">
      {items.map((item) => {
        const active = location.pathname === item.key;
        return (
          <div
            key={item.key}
            className={`bottom-tab-bar-item${active ? " active" : ""}`}
            onClick={() => history.push(item.key)}
          >
            <div className="bottom-tab-bar-icon">{item.icon}</div>
            <div className="bottom-tab-bar-label">{item.label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default BottomTabBar;
